import { TextField } from '../../common/FormFields';
import { Formik } from 'formik';
import { Button, Form } from 'semantic-ui-react';
import { connect } from 'react-redux';
import * as actions from '../../../redux/actions';
import { bindActionCreators } from 'redux';
import './Firm.scss';

const FirmSearchForm = ({ searchFirms }) => {
  const initialValues = {
    name: '',
  };

  const handleSubmit = query => {
    searchFirms(query);
  };

  const clearSearch = formik => {
    formik.resetForm();
    handleSubmit({});
  };

  return (
    <Formik initialValues={initialValues} onSubmit={handleSubmit}>
      {formik => (
        <Form className="firm-search-form" onSubmit={formik.handleSubmit}>
          <TextField
            name="name"
            label="Name"
            onChange={formik.handleChange}
            value={formik.values.name}
            formik={formik}
          />
          <Button content="Search" type="submit" onClick={formik.handleSubmit} fluid positive />
          <br />
          <Button content="Clear Search" onClick={() => clearSearch(formik)} fluid />
        </Form>
      )}
    </Formik>
  );
};

const mapStateToProps = state => ({});

const mapDispatchToProps = dispatch => ({
  searchFirms: bindActionCreators(actions.firm.searchFirms, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(FirmSearchForm);
